<template>
    <div class="form-input-radio-group">
        <slot />
    </div>
</template>

<style lang="scss">
.form-input-radio-group {
    display: flex;
    flex-flow: row wrap;
    align-items: center;
    margin-inline-start: -20px;

    @include bp(medium1) {
        margin-inline-start: -40px;
    }
}
</style>
